import { Box, Divider, Grid, TextField, Typography } from "@mui/material";
import React from "react";

import { LimitsAndControlsWorkerTypeHour } from "../../../../store/gat-admin-slice-types";

interface IWeeklyHourLimitsProps {
	workerTypeHours: LimitsAndControlsWorkerTypeHour[];
	workerSubTypeEnabled: boolean;
	getWorkerTypeName: (
		workerTypeId: number,
		workerSubTypeId: number | null
	) => string;
	onHoursChange: (
		workerTypeId: number,
		workerSubTypeId: number | null,
		type: "min" | "max",
		value: number
	) => void;
}

const styles = {
	container: {
		backgroundColor: "#F5F5F5",
		borderRadius: "8px",
		marginTop: "32px",
		padding: "16px",
	},
	gridContainer: {
		display: "flex",
		alignItems: "center",
		p: 2,
	},
	divider: {
		mx: 2,
		my: 1,
	},
	text: {
		fontFamily: "Roboto",
		fontSize: "16px",
		color: "rgba(0, 0, 0, 0.87)",
	},
	subText: {
		fontFamily: "Roboto",
		fontSize: "12px",
		color: "rgba(0, 0, 0, 0.6)",
	},
} as const;

const WeeklyHourLimits = ({
	workerTypeHours,
	workerSubTypeEnabled,
	getWorkerTypeName,
	onHoursChange,
}: IWeeklyHourLimitsProps) => {
	const visibleHours = workerSubTypeEnabled
		? workerTypeHours
		: workerTypeHours.filter((row) => row.workerSubTypeId === null);

	return (
		<Box sx={styles.container}>
			<Box>
				<Typography sx={styles.text}>Weekly hour limit</Typography>
				<Typography sx={styles.subText}>
					Minimum and maximum no. of hours a worker can work in a week at this
					location.
				</Typography>
			</Box>

			<Box sx={{ mt: 2 }}>
				<Grid container sx={styles.gridContainer}>
					<Grid item xs={6}>
						<Typography sx={{ ...styles.text, fontWeight: 500 }}>
							Worker
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<Typography sx={{ ...styles.text, fontWeight: 500 }}>
							Minimum (in hours)
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<Typography sx={{ ...styles.text, fontWeight: 500 }}>
							Maximum (in hours)
						</Typography>
					</Grid>
				</Grid>
				<Divider sx={styles.divider} />
				{visibleHours.map((row) => (
					<Grid
						container
						sx={styles.gridContainer}
						key={`${row.workerTypeId}-${row.workerSubTypeId}`}
					>
						<Grid item xs={6}>
							<Typography sx={styles.text}>
								{getWorkerTypeName(row.workerTypeId, row.workerSubTypeId)}
							</Typography>
						</Grid>
						<Grid item xs={3}>
							<TextField
								variant='filled'
								type='number'
								size='small'
								value={row.minHours}
								onFocus={(event) => {
									event.target.select();
								}}
								onChange={(e) =>
									onHoursChange(
										row.workerTypeId,
										row.workerSubTypeId,
										"min",
										parseInt(e.target.value)
									)
								}
								inputProps={{ min: 0, max: 168 }}
								sx={{ width: "120px" }}
							/>
						</Grid>
						<Grid item xs={3}>
							<TextField
								variant='filled'
								type='number'
								size='small'
								value={row.maxHours}
								onFocus={(event) => {
									event.target.select();
								}}
								onChange={(e) =>
									onHoursChange(
										row.workerTypeId,
										row.workerSubTypeId,
										"max",
										parseInt(e.target.value)
									)
								}
								inputProps={{ min: 0, max: 168 }}
								sx={{ width: "120px" }}
							/>
						</Grid>
					</Grid>
				))}
			</Box>
		</Box>
	);
};

export default WeeklyHourLimits;
